var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import App from './1_environment/App/App';
import { StringsContext } from './contexts/StringsContext';
import { getStringsByLanguage } from './utils/languageUtils';
export default {
    new: function (config) {
        var props = {
            token: config.token,
            brokerConfigId: config.brokerConfigId,
            apiDomain: config.apiDomain,
            warningTimeout: config.warningTimeout,
            sessionTimeout: config.sessionTimeout,
            sessionTimeoutCallback: (config === null || config === void 0 ? void 0 : config.sessionTimeoutCallback) || null,
            updateTokenCallback: (config === null || config === void 0 ? void 0 : config.updateTokenCallback) || null
        };
        var warningHeader = config.warningHeader, warningBody = config.warningBody, warningButton = config.warningButton, sessionHeader = config.sessionHeader, sessionBody = config.sessionBody, sessionButton = config.sessionButton, language = config.language;
        var customStrings = __assign(__assign(__assign(__assign(__assign(__assign({}, (warningHeader && { warningHeader: warningHeader })), (warningBody && { warningBody: warningBody })), (warningButton && { warningButton: warningButton })), (sessionHeader && { sessionHeader: sessionHeader })), (sessionBody && { sessionBody: sessionBody })), (sessionButton && { sessionButton: sessionButton }));
        // Combine default strings with overridden strings
        var strings = Object.assign({}, getStringsByLanguage(language), customStrings);
        var containerElement = document.querySelector(config.selector);
        var root = createRoot(containerElement);
        var appRef = createRef();
        var BUILD_TYPE = globalConstants.BUILD_TYPE, ENVIRONMENT = globalConstants.ENVIRONMENT, COMMIT_HASH = globalConstants.COMMIT_HASH, VERSION = globalConstants.VERSION;
        return {
            render: function (onRendered) {
                if (onRendered === void 0) { onRendered = null; }
                //eslint-disable-next-line no-console
                console.info('Taylor Corp - Timeout Widget', {
                    BuildType: BUILD_TYPE,
                    Environment: ENVIRONMENT,
                    CommitHash: COMMIT_HASH,
                    Version: VERSION
                });
                root.render(_jsx(React.StrictMode, { children: _jsx(StringsContext.Provider, { value: strings, children: _jsx(App, __assign({}, props, { ref: appRef, onInitialized: onRendered })) }) }));
            },
            setSessionTimeoutCallback: function (callback) {
                if (appRef.current) {
                    appRef.current.setSessionTimeoutCallback(callback);
                }
                else {
                    // The call to "TimeoutWidget.setSessionTimeoutCallback" was ignored, likely because "render" has not been called yet or the app has not completed rendering, as the render method does not execute synchronously. Use the "render" method\'s optional "onRendered" callback to run code after the app has finished rendering
                }
            },
            setUpdateTokenCallback: function (callback) {
                if (appRef.current) {
                    appRef.current.setUpdateTokenCallback(callback);
                }
                else {
                    // The call to "TimeoutWidget.setUpdateTokenCallback" was ignored, likely because "render" has not been called yet or the app has not completed rendering, as the render method does not execute synchronously. Use the "render" method\'s optional "onRendered" callback to run code after the app has finished rendering
                }
            },
            resetToken: function (brokerConfigId) {
                if (appRef.current) {
                    appRef.current.resetToken(brokerConfigId);
                }
                else {
                    // The call to "TimeoutWidget.resetToken" was ignored, likely because "render" has not been called yet or the app has not completed rendering, as the render method does not execute synchronously. Use the "render" method\'s optional "onRendered" callback to run code after the app has finished rendering
                }
            },
            unmount: function () {
                root.unmount();
            }
        };
    }
};
